module.exports = __webpack_public_path__ + "static/img/brees-2016-top.acfa33f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-top.jpg
// module id = wwHO
// module chunks = 1